import { render, staticRenderFns } from "./codemirror_unified_diff.vue?vue&type=template&id=8d86cfda&scoped=true"
import script from "./codemirror_unified_diff.vue?vue&type=script&lang=js"
export * from "./codemirror_unified_diff.vue?vue&type=script&lang=js"
import style0 from "./codemirror_unified_diff.vue?vue&type=style&index=0&id=8d86cfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d86cfda",
  null
  
)

export default component.exports